import React from 'react'
import { ISelectorOption } from '@trivie/core'

export interface SelectorListboxContextValue {
  showAvatar: boolean
  selectedOptionsRef: React.MutableRefObject<ISelectorOption[]>
  expandedIds: Set<number>
  onToggleExpand: (id: number) => void
  collapsibleGroups: boolean
  collapsedGroups: Set<string>
  onToggleGroupCollapse: (groupName: string) => void
}

export const SelectorListboxContext = React.createContext<SelectorListboxContextValue>({
  showAvatar: false,
  selectedOptionsRef: { current: [] },
  expandedIds: new Set(),
  onToggleExpand: () => {},
  collapsibleGroups: false,
  collapsedGroups: new Set(),
  onToggleGroupCollapse: () => {},
})
